let chart = undefined;
window.drawHistories = (arr) => {
    const cb = () => {
        const data = new google.visualization.DataTable();
        data.addColumn('date', '時刻');
        data.addColumn('number', '価格');
        data.addRows(JSON.parse(arr).map(([date, price]) => [new Date(date), price]));
        const options = {
            width: 900,
            height: 500,
            connectSteps: false,
            isStacked: true,
            hAxis: {
                format: 'MM/dd HH:mm',
                gridlines: {count: 15}
            },
            vAxis: {
                gridlines: {color: 'none'},
                format: 'decimal',
                minValue: 0,
                displayExactValues: true,
            }
        };

        if (chart === undefined) {
            chart = new google.visualization.AnnotatedTimeLine(document.getElementById('chart_div'));
        }

        chart.draw(data, options);
    };
    if (chart === undefined) {
        google.charts.load('current', {'packages':['annotatedtimeline']});
        google.charts.setOnLoadCallback(cb);
    } else {
        cb();
    }
};